const state = () => ({
    liberal: false,
    locative: false,
    country: null,
})

const getters = {
    getLiberal: (state) => {
        return state.liberal
    },
    getLocative: (state) => {
        return state.locative
    },
    getCountry: (state) => {
        return state.country
    },
}

const actions = {
    setLiberal({ commit }, value) {
        commit("SET_LIBERAL", value)
    },

    setLocative({ commit }, value) {
        commit("SET_LOCATIVE", value)
    },

    setCountry({ commit }, value) {
        commit("SET_COUNTRY", value)
    },
}

const mutations = {
    SET_LIBERAL(state, value) {
        state.liberal = value
    },
    SET_LOCATIVE(state, value) {
        state.locative = value
    },
    SET_COUNTRY(state, value) {
        state.country = value
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
